import config from 'constants/config'
import { getMapSearchMarkerCap, getMapSearchPageSize } from 'constants/searchHelpers'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import { useMemo } from 'react'

/**
 * Desktop maps use geographic coverage pins independently of list pagination.
 * List page size remains pinLimit (20) at every screen size.
 */
export default function useMapSearchPaging() {
  const geoDiversityEnabled = useScreenSizeUp('desktop')

  return useMemo(() => {
    const pageSize = getMapSearchPageSize(config.search.mapView)

    return {
      geoDiversityEnabled,
      pageSize,
      markerCap: getMapSearchMarkerCap(pageSize, config.search.mapView, geoDiversityEnabled),
    }
  }, [geoDiversityEnabled])
}
